<template>
  <BlocksContentArea v-if="content" :content="content" :get-component-func="getComponentByAlias" />
</template>

<script lang="ts" setup>
import type { ContentAreaContentType } from '@base/types/models';

interface ContentArea {
  content: ContentAreaContentType;
}

const { getComponentByAlias } = useWerkenbijCompMapper();

defineProps<ContentArea>();
</script>
